import React from 'react';
import { LoadingSpinner } from '../app';
import Styles from './Login.module.scss';
import { Container, Row, Col } from 'reactstrap';

export interface OwnProps {
  additionalClass: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

export const LoginPageContainer = (props: OwnProps) => {
  return (
    <>
      {props.isLoading && <LoadingSpinner className={`${Styles.container}`} />}

      <Container
        className={`${Styles.container} ${props.additionalClass}`}
        style={{ display: props.isLoading ? 'none' : undefined }}
      >
        <Row>
          <Col className={`col-12 col-lg-8 ${Styles.signInColumn}`}>{props.children}</Col>
        </Row>
      </Container>
    </>
  );
};

export const LoginPageContainerForNonDeviceCodeForms = (props: OwnProps) => {
  return (
    <LoginPageContainer {...props}>
      <Container>
        <Row>
          <Col className={`col-12 col-lg-6 ${Styles.formColumn}`}>{props.children}</Col>
        </Row>
      </Container>
    </LoginPageContainer>
  );
};
